import {
  faArrowDownZA,
  faArrowUpAZ,
  faCircleCheck,
  faCircleXmark,
} from "@fortawesome/free-solid-svg-icons";

const addHeadersToSectionList = (
  sectionList,
  isCaseListAscending,
  sortOrder,
  reviewLaterSections
) => {
  const sectionListCopy = structuredClone(sectionList);
  switch (sortOrder) {
    case "CaseNumber":
      for (let i = 0; i < sectionListCopy.length; ++i) {
        if (i % 11 === 0 && i + 9 < sectionListCopy.length) {
          sectionListCopy.splice(i, 0, {
            type: "logoText",
            text: "Section Number",
            headerText: `${sectionListCopy[i].sectionNumber} - ${
              sectionListCopy[i + 9].sectionNumber
            }`,
          });
          i += 1;
        } else if (i % 11 === 0) {
          sectionListCopy.splice(i, 0, {
            type: "logoText",
            text: "Section Number",
            headerText: `${sectionListCopy[i].sectionNumber} - ${
              sectionListCopy[sectionListCopy.length - 1].sectionNumber
            }`,
          });
          i += 1;
        }
      }
      break;
    case "CompletionDate":
      for (let i = 0; i < sectionListCopy.length; ++i) {
        const isSectionCompleted = sectionListCopy[i].Completed;
        const isSectionCompletionInvalid =
          sectionListCopy[i].MostRecentCompletionDate === "0001-01-01T00:00:00";
        const isSectionCompletedAndValid =
          isSectionCompleted && !isSectionCompletionInvalid;

        if (i === 0) {
          sectionListCopy.splice(i, 0, {
            type: "icon",
            text: isSectionCompletedAndValid
              ? "Completed Sections"
              : "Incomplete Sections",
            icon: isSectionCompletedAndValid ? faCircleCheck : faCircleXmark,
          });
          if (isCaseListAscending) i += 1;
        }

        const isNextSectionCompleted = sectionListCopy[i + 1]?.Completed;
        const isNextSectionCompletionInvalid =
          sectionListCopy[i + 1]?.MostRecentCompletionDate ===
          "0001-01-01T00:00:00";
        const isNextSectionCompletedAndValid =
          isNextSectionCompleted && !isNextSectionCompletionInvalid;

        if (isSectionCompletedAndValid && !isNextSectionCompletedAndValid) {
          sectionListCopy.splice(i + 1, 0, {
            type: "icon",
            text: "Incomplete Sections",
            icon: faCircleXmark,
          });
          break;
        }
        if (!isSectionCompletedAndValid && isNextSectionCompletedAndValid) {
          sectionListCopy.splice(i + 1, 0, {
            type: "icon",
            text: "Completed Sections",
            icon: faCircleCheck,
          });
          break;
        }
      }
      break;
    case "ReviewLater":
      if (sectionListCopy.length === 0) break;

      const isFirstSectionMarked =
        isCaseListAscending &&
        reviewLaterSections[sectionListCopy[0].sectionId];

      sectionListCopy.splice(0, 0, {
        type: "icon",
        text: isFirstSectionMarked ? "Review Later" : "Unmarked Sections",
        icon: isFirstSectionMarked ? faCircleCheck : faCircleXmark,
      });

      for (let i = 1; i < sectionListCopy.length - 1; ++i) {
        const isSectionMarked =
          reviewLaterSections[sectionListCopy[i].sectionId];
        const isNextSectionMarked =
          reviewLaterSections[sectionListCopy[i + 1].sectionId];
        if (
          (isSectionMarked && !isNextSectionMarked) ||
          (!isSectionMarked && isNextSectionMarked)
        ) {
          sectionListCopy.splice(i + 1, 0, {
            type: "icon",
            text: isCaseListAscending ? "Unmarked Sections" : "Marked Sections",
            icon: isCaseListAscending ? faCircleXmark : faCircleCheck,
          });
          break;
        }
      }
      break;
    case "AverageGrade":
      for (let i = 0; i < sectionListCopy.length; ++i) {
        const isSectionCompleted = sectionListCopy[i].Completed;
        const isSectionCompletionInvalid =
          sectionListCopy[i].MostRecentCompletionDate === "0001-01-01T00:00:00";
        const isSectionCompletedAndValid =
          isSectionCompleted && !isSectionCompletionInvalid;

        if (i === 0) {
          sectionListCopy.splice(i, 0, {
            type: "icon",
            text: isSectionCompletedAndValid
              ? "Average Grade"
              : "Incomplete Sections",
            icon: isSectionCompletedAndValid ? faCircleCheck : faCircleXmark,
          });
          if (isCaseListAscending) i += 1;
        }

        const isNextSectionCompleted = sectionListCopy[i + 1]?.Completed;
        const isNextSectionCompletionInvalid =
          sectionListCopy[i + 1]?.MostRecentCompletionDate ===
          "0001-01-01T00:00:00";
        const isNextSectionCompletedAndValid =
          isNextSectionCompleted && !isNextSectionCompletionInvalid;

        if (isSectionCompletedAndValid && !isNextSectionCompletedAndValid) {
          sectionListCopy.splice(i + 1, 0, {
            type: "icon",
            text: "Incomplete Sections",
            icon: faCircleXmark,
          });
          break;
        }
        if (!isSectionCompletedAndValid && isNextSectionCompletedAndValid) {
          sectionListCopy.splice(i + 1, 0, {
            type: "icon",
            text: "Average Grade",
            icon: faCircleCheck,
          });
          break;
        }
      }
      break;
    case "CaseTitle":
      if (isCaseListAscending) {
        if (sectionListCopy.length > 0) {
          sectionListCopy.splice(0, 0, {
            type: "icon",
            text: "Title",
            icon: faArrowUpAZ,
          });
        }
      } else {
        if (sectionListCopy.length > 0) {
          sectionListCopy.splice(0, 0, {
            type: "icon",
            text: "Title",
            icon: faArrowDownZA,
          });
        }
      }
      break;
    default:
      break;
  }
  return sectionListCopy;
};

export default addHeadersToSectionList;
